export default function () {
	$.nette.ext({
		before: function (xhr, settings) {
			if (!settings.nette) {
				return;
			}

			var question = settings.nette.el.data('confirm');
			if (question) {
				let c = confirm(question);
				if (
					c === false &&
					this.ext('nanobar') instanceof Object &&
					typeof this.ext('nanobar').reset === 'function' &&
					this.ext('nanobar').nanobar instanceof Object &&
					typeof this.ext('nanobar').nanobar.go === 'function'
				) {
					this.ext('nanobar').reset();
					this.ext('nanobar').nanobar.go(0);
				}
				return c;
			}
		}
	});
}
